import { ItemCardWithPieces } from "@coworker/apprestructured/src/shared/components/item-cards/ItemCardWithPieces/ItemCardWithPieces";
import { ItemWithPieces } from "@coworker/apprestructured/src/shared/types/item";
import { ItemNoAndTypeWithOrderedDetails } from "@coworker/apprestructured/src/task-management/types/TaskDetailTypes";
import { FixaQuantityStepper } from "@coworker/apprestructured/src/shared/wrappers/FixaQuantityStepper/FixaQuantityStepper";
import React from "react";
import { Loading } from "@coworker/apprestructured/src/task-management/loading";
import styles from "./ArticlesQuantityContent.module.css";

interface ArticlesQuantityContentProps {
  itemsWithPieces: ItemWithPieces[];
  itemsNoAndTypeOrderedDetails:
    | ItemNoAndTypeWithOrderedDetails[]
    | null
    | Loading;
  handlePiecesChange: (itemNo: string, newPieces: number) => void;
}

export const ArticlesQuantityContent = ({
  itemsWithPieces,
  itemsNoAndTypeOrderedDetails,
  handlePiecesChange,
}: ArticlesQuantityContentProps) => {
  const piecesByItemNo = new Map(
    Array.isArray(itemsNoAndTypeOrderedDetails)
      ? itemsNoAndTypeOrderedDetails.map(({ no, pieces, pieces_ordered }) => [
          no,
          { pieces, ordered_quantity: pieces_ordered.quantity },
        ])
      : []
  );

  return (
    <>
      {itemsWithPieces.map((item) => (
        <React.Fragment key={item.no}>
          <ItemCardWithPieces item={item} />
          <div className={styles["stepper"]}>
            <FixaQuantityStepper
              small
              fluid
              defaultValue={
                piecesByItemNo.get(item.no)?.ordered_quantity ??
                piecesByItemNo.get(item.no)?.pieces ??
                0
              }
              ariaDescribedById={`item-pieces-quantity-stepper-${item.no}`}
              ariaDescribedBy={`quantity-stepper-${item.no}`}
              minVal={1}
              maxVal={piecesByItemNo.get(item.no)?.pieces ?? 0}
              onQuantityChange={(newQuantity) =>
                handlePiecesChange(item.no, Number(newQuantity))
              }
            />
          </div>
        </React.Fragment>
      ))}
    </>
  );
};
